import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Row, Col, Spin, Button } from 'antd';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { Container, Title } from 'src/components';
import { IReduxState } from 'src/store';
import { fetchTasks, updateStageTask } from 'src/store/tasks/actions';

import List from './components/list/list.component';
import Filter from './components/filter/filter.component';

import { Wrapper, Header, Board } from './board.style';
import { IProps } from './board.type';
import useBoard from './board.use';

const BoardComponent: React.FC<IProps> = (props) => {
  const sectors = useSelector((state: IReduxState) => state.sectors.all) || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { handleTasks, handleDragEnd, loading, reload, handleReload } =
    useBoard(props);

  const { board } = props;

  useEffect(() => {
    dispatch({
      type: 'CLEAR_BOARD',
    });

    handleTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, reload]);

  return (
    <Wrapper>
      <Container type="fluid" className="mt-4">
        <Row gutter={8}>
          <Col span={24}>
            <Header className="m-0 p-0">
              <Row gutter={[8, 8]} justify="space-between" align="middle">
                <Col xs={24} md={16} lg={18}>
                  <Title
                    foreword="Ordem de serviço"
                    title="Quadro de ordem de serviços"
                    className="p-0 d-inline"
                  />
                </Col>
                <Col
                  xs={24}
                  md={8}
                  lg={6}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    size="small"
                    type="dashed"
                    onClick={() => navigate('/painel/board/technicians')}
                    className="mb-1 mt-2"
                  >
                    <small>
                      <b>MODO DE EXIBIÇÃO: TÉCNICO</b>
                    </small>
                  </Button>
                </Col>
              </Row>
              <Row gutter={[8, 8]} justify="space-between" align="middle">
                <Col xs={24} md={16} lg={18} style={{ minWidth: 0 }}>
                  <Filter handleReload={handleReload} sectors={sectors} />
                </Col>
                <Col
                  xs={24}
                  md={8}
                  lg={6}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => navigate('/painel/tarefas/nova')}
                  >
                    Adicionar Nova
                  </Button>
                </Col>
              </Row>
            </Header>

            {!loading ? (
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable
                  droppableId="board"
                  direction="horizontal"
                  type="COLUMN"
                >
                  {(provided: any, _snapshot: any) => (
                    <Board ref={provided.innerRef}>
                      {board?.lists?.map((listId: string, index: number) => {
                        return (
                          <List
                            handleReload={handleReload}
                            listId={listId}
                            key={listId}
                            index={index}
                          />
                        );
                      })}
                    </Board>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable
                  droppableId="board"
                  direction="horizontal"
                  type="COLUMN"
                >
                  {(provided: any, _snapshot: any) => (
                    <Board ref={provided.innerRef}>
                      {board?.lists?.map((listId: string, index: number) => {
                        return (
                          <List
                            handleReload={handleReload}
                            listId={listId}
                            key={listId}
                            index={index}
                          />
                        );
                      })}
                    </Board>
                  )}
                </Droppable>
                <Spin spinning={loading} fullscreen />
              </DragDropContext>
            )}
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

const mapStateToProps = (state: IReduxState) => ({ board: state.board });

export default connect(mapStateToProps, { fetchTasks, updateStageTask })(
  BoardComponent
);
